import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { patientCreditReasonQueryOptions } from "@/query/settings/patient-credit-reason";
export function usePatientCreditReasons() {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = patientCreditReasonQueryOptions.list();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const query = useQuery(t0);
  let t1;
  if ($[1] !== query.data) {
    t1 = query.data ?? [];
    $[1] = query.data;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = t1.filter(_temp);
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== query || $[6] !== t2) {
    t3 = {
      ...query,
      patientCreditReasons: t2
    };
    $[5] = query;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(reason) {
  return !reason.isArchived;
}